/**
 * @license @tabler/icons-solidjs v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from './defaultAttributes.js';
import { splitProps } from 'solid-js';
import h from 'solid-js/h';

const createSolidComponent = (type, iconName, iconNamePascal, iconNode) => {
  const Component = (props) => {
    const [localProps, rest] = splitProps(props, ["color", "size", "stroke", "title", "children", "class"]), attributes = defaultAttributes[type];
    const svgProps = {
      ...attributes,
      width: () => localProps.size != null ? localProps.size : attributes.width,
      height: () => localProps.size != null ? localProps.size : attributes.height,
      title: () => localProps.title != null ? localProps.title : void 0,
      ...type === "filled" ? {
        fill: () => localProps.color != null ? localProps.color : "currentColor"
      } : {
        stroke: () => localProps.color != null ? localProps.color : "currentColor",
        "stroke-width": () => localProps.stroke != null ? localProps.stroke : attributes["stroke-width"]
      },
      class: () => `tabler-icon tabler-icon-${iconName} ${localProps.class != null ? localProps.class : ""}`
    };
    return h(
      "svg",
      [svgProps, rest],
      [
        localProps.title && h("title", {}, localProps.title),
        ...iconNode.map(([tag, attrs]) => h(tag, attrs)),
        localProps.children
      ]
    );
  };
  Component.displayName = `${iconNamePascal}`;
  return Component;
};

export { createSolidComponent as default };
//# sourceMappingURL=createSolidComponent.js.map
